// Intefaces
import IAvailableSlot from "../interfaces/IAvailableSlot";

// NPM
import moment from "moment";
import IAppointmentRecord from "../interfaces/IAppointmentRecord";

export default class AvailableSlot {
	/**
	 * This function generate a string that states from when to when a doctor is available.
	 *
	 * @param slots All the available slot that belongs to a doctor
	 * @returns the string that states when the doctor is available
	 */
	public static generateTimeAvailability(slots: IAvailableSlot[]): string {
		const indexOfLast = slots.length - 1;

		const first = moment(slots[0].startDateTime).format("h:mm A");
		const last = moment(slots[indexOfLast].startDateTime).format("h:mm A");

		if (first === last) {
			return "Only " + first + " available";
		}

		return first + " to " + last + " available";
	}

	public static filterSlotDuration(
		slot: IAvailableSlot,
		index: number,
		array: IAvailableSlot[],
		minimumDuration: number
	): boolean {
		const minDuration: number = minimumDuration;

		const slotDuration: number = slot.slotDuration / 60;

		const requiredNumberOfSlots: number = minDuration / slotDuration;

		const lastRequiredIndex: number = index + requiredNumberOfSlots - 1;

		if (lastRequiredIndex >= array.length) {
			return minDuration === slotDuration;
		}

		const currentSlot = slot;
		const lastSlot = array[lastRequiredIndex];

		const currentSlotMoment = moment(currentSlot.startDateTime);
		const lastSlotMoment = moment(lastSlot.startDateTime);

		const minsDiff = Math.abs(
			currentSlotMoment.diff(lastSlotMoment, "minutes")
		);

		const numberOfConsecutiveSlots: number = minsDiff / slotDuration;

		return numberOfConsecutiveSlots === requiredNumberOfSlots - 1;
	}

	public static sortByTime(
		a: IAppointmentRecord,
		b: IAppointmentRecord
	): number {
		const aSlot = a.availableSlots[0].startDateTime;
		const bSlot = b.availableSlots[0].startDateTime;

		if (moment(aSlot).isBefore(bSlot)) return -1;
		if (moment(bSlot).isBefore(aSlot)) return 1;

		return 0;
	}
}
